<!-- 提示弹框 -->
<template>
  <div class='publicDialog' ref="publicDialog">
    <div class="dialog" :style="{'height':height?height:'3.32rem'}">
      <div class="title">
        {{title}}
      </div>
      <div class="info" v-if="dialogType ==='topay'||dialogType ==='tounion'" v-html="info">
      </div>
      <div class="info" v-else>
        {{info}}
      </div>
      <div class="btns" :class="{'onlyOne':btn1.length===0}">
        <div class="btn btn1" :class="{'two':btn1.length>0}" v-if="btn1!=''" @click="handleBtn1Click">{{btn1}}</div>
        <div class="btn btn2" :class="{'two':btn1.length>0}" @click="handleBtn2Click">{{btn2}}</div>
      </div>
    </div>
    <!-- 取消自动支付的弹窗 -->
    <div class="cancelAutoDiaLog" v-if="autoDialogIsSHow">
      <div class="autoDialogTitle">
        取消自动续费
      </div>
      <div class="autoDialogInfo">
        <div class="info1">
          根据苹果公司规定，您需要到苹果设备上登录您开通自动续费的AppleID来取消续费
        </div>
        <div class="info2">
          取消方法：在使用中国体育相关功能或服务，我们会收集、使用您的必要信息，并与第三方数据公司合作为您提供一个更好的服务
        </div>
        <div class="info3">
          通讯录、摄像头、麦克风、相册、GPS等敏感权限需提前获得您的授权，相关功能或服务才会开启
        </div>
      </div>
      <div class="autoDialogBtns">
        <!-- <div class="autoBtn" @click="handleCloseAutoDialog">
          关闭
        </div> -->
        <div class="autoBtn iKnow" @click="handleCloseAutoDialog">
          我知道了
        </div>
      </div>
    </div>
    <!-- 支付成功后的提示 -->
    <publicCoupon v-if="paySuccess"></publicCoupon>
  </div>
</template>

<script>
import publicCoupon from './PublicCoupon'
export default {
  props: ['info', 'title', 'btn1', 'btn2', 'dialogIsShow', 'paySuccess', 'height','platForm','dialogType'],
  components: { publicCoupon },
  data () {
    return {
      isShow: this.dialogIsShow,
      // 是否是IOS
      isIOS: false,
      // 是否展示自动续费弹窗
      autoDialogIsSHow: false
    }
  },
  watch: {
    isShow (val) {
      this.dialogIsShow = val;
    }
  },
  created () {
    console.log(this.height);
    this.isIOS = this.$CONFIG.isIOS
  },
  methods: {
    doClose () {
      // 触发父组件中的dialogVisibleEvent事件，并传递参数
      this.$emit('changeShow', false);
    },
    handleBtn1Click () {

      // this.isShow=false
      // if(this.$props.btn2==='我知道了' || this.$props.btn2==='取消'){
      //   this.isShow=false
      // }
      if (this.btn1 === '确认关闭') {
        // platForm2苹果
        if (this.platForm===2) {
          this.autoDialogIsSHow = true
        } else {
          this.$emit('closeRenew')
          this.doClose()
        }
      }
      if (this.btn1 === '管理') {
        alert('调IOS方法跳转到iTunes进行退订')
      }
      if (this.btn1 === '重新支付') {
        this.doClose()
        this.handleAuto()
      }
      // this.doClose()
    },
    handleBtn2Click () {
      this.doClose()
      
      if (this.btn2 === '去充值') {
        //充值
        try {
          window.webkit.messageHandlers.recharge.postMessage('recharge');
        } catch (e) { console.log('error') }
        try {
          window.LiveAppJS.recharge();
        } catch (e) { console.log('error') }

      }
      else if (this.btn2 === '已支付') {
        this.handleAuto()
      }else if (this.dialogType==='topay' && this.btn2==='我知道了') {
        this.$emit('openPay')
      }else if (this.dialogType==='tounion' && this.btn2==='我知道了') {
        this.$emit('gotoUnion')
      }else{
        console.log(this.dialogType,this.btn2);
        window.location.reload()
      }
      
      // this.isShow=false
      // if(this.$props.btn2==='我知道了' || this.$props.btn2==='取消'){
      //   this.isShow=false
      // }

    },
    // 关闭自动续费的点击事件
    handleCloseAutoDialog () {
      this.doClose()
      window.location.reload()
    },
    // 0507需求处理连续包月
    handleAuto(){
      console.log('处理连续包月');
      this.$emit('getAutoStatus')
    }
  },
}
</script>
<style lang='less' scoped>
.publicDialog {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index:3;
  .dialog {
    width: 6.2rem;
    height: 3.32rem;
    padding: 0.5rem 0.3rem 0.3rem 0.3rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.2rem;
    position: absolute;
    // white-space: nowrap;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    // 标题
    .title {
      font-size: 0.36rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    //
    .info {
      padding: 0 0.26rem;
      font-size: 0.3rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 0.42rem;
      text-align: center; 
      p{
        display: inline-block;
        font-weight: 600;
      }
    }
    // 按钮
    .btns {
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 0.28rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #613f25;
      .btn {
        width: 3rem;
        height: 0.9rem;
        background: linear-gradient(145deg, #f5e4d3 0%, #c4a485 100%);
        border-radius: 0.45rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .btn1 {
        background: #f7f8fc;

        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
      }
      .btn2 {
        background: linear-gradient(145deg, #f5e4d3 0%, #c4a485 100%);
      }
      .two {
        width: 2.7rem;
      }
    }
    .onlyOne {
      justify-content: center;
    }
  }
  .h470 {
    height: 4.7rem;
  }
  // 取消自动续费的弹窗
  .cancelAutoDiaLog {
    width: 6.2rem;
    height: 7.8rem;
    background: #ffffff;
    border-radius: 0.2rem;
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .autoDialogTitle {
      height: 1.35rem;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      border-bottom: 1px solid #e5e5e5;
      font-size: 0.4rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
    }
    .autoDialogInfo {
      margin: 0.5rem 0.56rem 0.7rem 0.56rem;
      border-bottom: 0.01rem solid #e5e5e5;
      .info1 {
        margin-bottom: 0.3rem;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
      }
      .info2 {
        margin-bottom: 0.14rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #888888;
        line-height: 0.33rem;
      }
      .info3 {
        margin-bottom: 0.3rem;
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #888888;
        line-height: 0.33rem;
      }
    }
    .autoDialogBtns {
      margin: 0.3rem;
      display: flex;
      justify-content: center;
      .autoBtn {
        width: 2.7rem;
        height: 0.9rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f6f7f9;
        border-radius: 0.45rem;
        opacity: 0.8;

        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        text-align: center;
      }
      .iKnow {
        background: linear-gradient(132deg, #f5e4d3 0%, #c4a485 100%);

        font-weight: 600;
        color: #613f25;
      }
    }
  }
}
</style>
